export default __webpack_public_path__ + "static/media/passage.c710aea2.svg";